import { call, put, takeLatest } from 'redux-saga/effects'

import { isMobile } from '@/utils/featureChecks'

import { toast } from '../../notifications'

import { share, shareFailure, shareSuccess } from './actions'

export const SUCCESS_MESSAGE = 'Share successfull'
export const FAILURE_MESSAGE = 'Share failed'

export function * executeShare (
  {
    payload: {
      title,
      url,
      text
    },
    meta: {
      successMessage = SUCCESS_MESSAGE,
      failureMessage = FAILURE_MESSAGE
    } = {}
  }
) {
  if (navigator.share && isMobile()) {
    try {
      yield call(navigator.share.bind(navigator), { title, text, url })
      yield put(shareSuccess(SUCCESS_MESSAGE))
      yield call(toast, SUCCESS_MESSAGE, { type: 'success' })
    } catch (error) {
      console.log(error)
      yield put(shareFailure(FAILURE_MESSAGE))
      if (error && error.name !== 'AbortError') {
        yield call(toast, FAILURE_MESSAGE, { type: 'error' })
      }
    }
  }
}

export default takeLatest(share, executeShare)
